import { Component, OnInit, OnDestroy, ViewChild, ViewChildren, QueryList, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { MatSort, MatTableDataSource, MatPaginator,MatInput, MatDialog } from '@angular/material';
import { ChartType } from 'chart.js';
import { Label, BaseChartDirective } from 'ng2-charts';
import { ReportService } from '../report.service';
import { getLocationType, getCustomizedGeo, addLiveChangeState } from '../report';
import { report_leftmenu, NewDeviceTypeDesc, enumReportState, enumgetResidentData } from '../../../app-settings';
import { Subject } from 'rxjs';
import { MediaObserver, MediaChange } from '@angular/flex-layout';
import { takeUntil, filter } from 'rxjs/operators';
import { SessionCheckwithStaff, generateAlertMessage } from '../../../app-general';
import { DownloadLiveviewReportComponent } from '../download-liveview-report/download-liveview-report.component';
import { ConfirmMessageComponent } from '../../../confirm-message/confirm-message.component';
import { MainLayoutService } from '../../../main-layout/main-layout.service';
import { InfrastructureAlertsComponent } from '../../../main-layout/alerts/infrastructure-alerts/infrastructure-alerts.component';
import { SidenavComponent } from '../../../main-layout/sidenav/sidenav.component';
import { ReportHeaderComponent } from '../report-header/report-header.component';
import { AlertSharedService } from '../../../_services/index';
import { ApiService } from '../../../api.service';
import { getStaffData } from '../../../api';

declare var Chart: any;

@Component({
  selector: 'app-liveview',
  templateUrl: './liveview.component.html',
  styleUrls: ['./liveview.component.scss']
})
export class LiveviewComponent implements OnInit {
  ReportType = report_leftmenu.liveviewReport;
  private _onDestroy: Subject<void> = new Subject<void>();
  public EnumNewDeviceType = NewDeviceTypeDesc;
  public EnumReportState = enumReportState;
  smcurrentScreenWidth: string = 'sm';
  xscurrentScreenWidth: string = 'xs';
  mdcurrentScreenWidth: string = 'md';
  liveviewinterval;
  IsRefreshNeed = 1;
  constructor(private router: Router,private mediaObserver: MediaObserver, private reportService: ReportService,public dialog: MatDialog,
    public mainLayoutService:MainLayoutService, private alertSharedService: AlertSharedService,private apiService: ApiService) { 
      mediaObserver.media$.subscribe((change: MediaChange) => {

        if (change.mqAlias == this.xscurrentScreenWidth) {
          this.setupliveTableforXtrasmallerwidth();
        }
        else if (change.mqAlias == this.smcurrentScreenWidth) {
          this.setupliveTableforsmallerwidth();
        }
        else if (change.mqAlias == this.mdcurrentScreenWidth) {
          this.setupliveTableformidwidth();
        }
        else {
          this.setupliveFullTable();
        }
      });
    }

  monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']; 
  displayedLiveViewColumns: string[] = ['GeoName', 'R_TagId', 'TruLocation', 'Updatedon', 'TypeName','stateChangebyName','roomcolor'];

  SiteId = "1";
  todaydate; Todaydate;
  liveviewloading = true;
  LiveViewReport;
  LiveViewSource;
  TotalLiveViewSource;
  cusloc_selectStateBy;
  selectedLocationType;
  downloadLiveviewdata;
  LiveviewData = [];
  TotalNumofLiveView;
  LiveViewReportCount;
  LocationType;
  Pop_LocationData : any[];
  chkLiveviewsearchvalue;
  CusLocfilteredArray = [];
  cusloc_selstatechange = [];
  IsLoaded = 0;
  IsFilter = 0;
  IsFilterData = "";
  
  @ViewChild('searchLiveViewInput') searchLiveViewInput: ElementRef;
  @ViewChild('LiveViewsort') LiveViewsort: MatSort;
  @ViewChildren(MatPaginator) paginator = new QueryList<MatPaginator>();
 
  // multi Doughnut start
  public LiveViewdoughnutChartLabels1: Label[] = ['Alert 3', 'Alert 2', 'Alert 1'];
  public LiveViewdonutColors1 = [];
  public LiveViewoptions1 = {};
  public LiveViewdatasets: Array<any> = [];
  public LiveViewdoughnutChartType1: ChartType = 'doughnut';

//LiveView Report///
setupliveTableforXtrasmallerwidth() {
  this.displayedLiveViewColumns = ['GeoName','R_TagId', 'Updatedon'];
}
setupliveTableforsmallerwidth() {
  this.displayedLiveViewColumns = ['GeoName','R_TagId', 'Updatedon'];
}
setupliveTableformidwidth()
{
  this.displayedLiveViewColumns = ['GeoName', 'R_TagId', 'TruLocation', 'Updatedon', 'TypeName'];
}
setupliveFullTable() { 
  this.displayedLiveViewColumns = [ 'GeoName', 'R_TagId', 'TruLocation', 'Updatedon', 'TypeName','stateChangebyName','roomcolor' ];
}


  ngOnInit() {
    this.todaydate = new Date();     
    this.Todaydate = this.monthNames[this.todaydate.getMonth()] + ' ' + ('0' + (this.todaydate.getDate())).slice(-2) + ', ' + this.todaydate.getFullYear();
    this.getLocationType(); 
    this.getCustomizedGeo("");

    this.liveviewinterval = setInterval(() => {
      
      this.todaydate = new Date();
      this.Todaydate = this.monthNames[this.todaydate.getMonth()] + ' ' + ('0' + (this.todaydate.getDate())).slice(-2) + ', ' + this.todaydate.getFullYear();      
      if(this.IsFilter == 0)
      {
        this.getCustomizedGeo("");
      }
      else
      {
        this.getCustomizedGeo(this.IsFilterData);
      }
      this.getStaffData();
    }, ((1000 * 60 * 1)));


  }

getLocationType()
{
  try
  {  
    this.liveviewloading = true; 
    var locationtypeitem : getLocationType = 
    {
      siteId:this.SiteId, 
      authKey: localStorage.getItem("Authkey")
    }  
    this.reportService.getLocationType(locationtypeitem).pipe(takeUntil(this._onDestroy))
    .subscribe((LocationTypeReport: any[]) => {                
          this.LocationType = LocationTypeReport;   
        localStorage.setItem('Clean', this.LocationType[0].TypeName); 
        localStorage.setItem('InUse', this.LocationType[1].TypeName);                             
        localStorage.setItem('Dirty', this.LocationType[2].TypeName); 
        localStorage.setItem('Unknown', this.LocationType[3].TypeName);                      
    });  
    this.getStaffData();
  }
  catch (err) {
    throw new Error('report.component.ts' + ' - getLocationType() - ' + err.message);
    }  
}

getStaffData()
{
  try
  {     
    var staffdata : getStaffData = { authKey: localStorage.getItem("Authkey")};  
    this.apiService.getStaffData(staffdata).pipe(takeUntil(this._onDestroy))
    .subscribe((Staffdetails: any[]) => {                       
    this.cusloc_selstatechange =  Staffdetails["apiReturn"];             
    });       
  }
  catch (err) {
    throw new Error('report.component.ts' + ' - getStaffData() - ' + err.message);
  }  
}

getCustomizedGeo(filtervalue)
{
  try
  {        
    if(this.IsFilterData == '0')
    {
      this.cusloc_selectStateBy = 0;
      this.selectedLocationType = 0;
    }
    this.liveviewloading = true;         
    var customgeoitem : getCustomizedGeo = 
    {
      siteId:this.SiteId, 
      authKey: localStorage.getItem("Authkey"),
      dateFormat:localStorage.getItem("dateFormat")
    }    
    this.reportService.getCustomizedGeo(customgeoitem).pipe(takeUntil(this._onDestroy))
      .subscribe((LiveViewData: any[]) => {
      this.liveviewloading = false;       
      this.LiveViewReport = LiveViewData; 
        
      this.LiveViewSource = new MatTableDataSource(this.LiveViewReport); 
      this.LiveViewSource = new MatTableDataSource(this.LiveViewReport);       
      this.TotalLiveViewSource = new MatTableDataSource(this.LiveViewReport);
      this.downloadLiveviewdata = new MatTableDataSource(this.LiveViewReport);     
      this.LiveViewSource.data = LiveViewData; 
      this.LiveViewSource.data = LiveViewData;
      this.TotalLiveViewSource.data = LiveViewData;                
      
      this.downloadLiveviewdata.data = this.LiveViewReport;      
      this.LiveViewSource.paginator = this.paginator.toArray()[0];      
        setTimeout(() => {
          this.LiveviewData = [];
          this.LiveViewSource.sort = this.LiveViewsort;
          this.sortingDatalist_LiveViewReport(this.LiveViewSource);                
          this.downloadLiveviewdata.sort = this.LiveViewsort;
          this.sortingDatalist_LiveViewReport(this.downloadLiveviewdata);
          this.downloadLiveviewdata.connect().subscribe(data =>
            this.LiveviewData = data
          );
        }, 0);
        if (filtervalue != undefined && filtervalue != null && filtervalue != "") { // if filter value then we referesh new alert need to retain the filter.
          this.getfilterLiveViewdetails();
        }  
      this.loadliveviewchart();
                
        });
    }
    catch (err) {
      throw new Error('report.component.ts' + ' - getCustomizedGeo() - ' + err.message);
    } 
}

loadliveviewchart()
  {
    try
    {                    
        var liveviewData = [];
        var Avg_count1 = 0, Avg_count2 = 0, Avg_count3 = 0, Avg_count4 = 0, Avg_count5 = 0;                      
          liveviewData = this.TotalLiveViewSource.data; 
          this.TotalNumofLiveView = liveviewData.length; 
          if(liveviewData.length == 0)          
            this.LiveViewReportCount = "";
          else if(liveviewData.length == 1)
            this.LiveViewReportCount = liveviewData.length + ' TruLocator';
          else            
            this.LiveViewReportCount = liveviewData.length + ' TruLocators'; 

          for(var i = 0; i < liveviewData.length; i++)
          {
           
            if(liveviewData[i].roomcolor == enumReportState.Clean)  //Green          
                Avg_count1 = Avg_count1 + 1;
            
            else if(liveviewData[i].roomcolor == enumReportState.InUse)    //Yellow        
                Avg_count2 = Avg_count2 + 1;
            
            else if(liveviewData[i].roomcolor == enumReportState.Dirty)  //Red
                Avg_count3 = Avg_count3 + 1;

            else if(liveviewData[i].roomcolor == enumReportState.Unknown) //Gray       
                Avg_count4 = Avg_count4 + 1;                                               
            
          }
          Avg_count5 = liveviewData.length;         

          Chart.defaults.global.legend.labels.usePointStyle = true;
          
          var Alert1 = Avg_count1;
          var Alert2 = Avg_count2;
          var Alert3 = Avg_count3;
          var Alert4 = Avg_count4;
          var Alert5 = Avg_count5;
                 
         
          var temp1, temp2, temp3, temp4 = 0;           
          if(Alert4 == 0)
            temp1 = 0;
          else
            temp1 = Math.round((Alert4 / Alert5) * 100);  
          
          if(Alert3 === 0) 
            temp2 = 0;
          else
            temp2 = Math.round((Alert3 / Alert5) * 100);

          if(Alert2 === 0) 
            temp3 = 0;
          else
            temp3 = Math.round((Alert2 / Alert5) * 100);

          if(Alert1 === 0) 
            temp4 = 0;
          else
            temp4 = Math.round((Alert1 / Alert5) * 100);
         
            
          this.LiveViewdatasets = [
               
            [Alert4, Alert5 - Alert4],//Gray
            [Alert3, Alert5 - Alert3],//Red
            [Alert2, Alert5 - Alert2],//Yellow        
            [Alert1, Alert5 - Alert1],//Green 

          ];          

          this.LiveViewdonutColors1 = [{

            backgroundColor: [
              '#797777',//Gray             
              '#fafafa',
            ]
          }, {

            backgroundColor: [
              '#FF0000',//Red              
              '#fafafa',
            ]
          }, {

            backgroundColor: [
              '#F7FE2E',//Yellow
              '#fafafa',
            ]

          },
          {
            backgroundColor: [
              '#3ADF00',//Green
              '#fafafa',
            ]

          }];                    
         
          var Clean = localStorage.getItem("Clean").trim();
          var InUse = localStorage.getItem("InUse").trim();
          var Dirty = localStorage.getItem("Dirty").trim();
          var Unknown = localStorage.getItem("Unknown").trim();        

          this.LiveViewoptions1 = {

            tooltips: {
              enabled: false
            },

            rotation: 190,           

            legend: {
              display: true,
              position: 'right',


              labels: {
                width:'250px',
                generateLabels() {
                  return [                                     
                  {                    
                    tooltips: 'Clean',
                    text: temp4 + '% ' + Clean,
                    fillStyle: '#70F519',
                    strokeStyle: '#fff' ,                                
                  },
                  {
                    tooltips: InUse,
                    text: temp3 + '% ' + InUse,
                    fillStyle: '#EEF519',
                    strokeStyle: '#fff'
                  },
                  {
                    tooltips: Dirty,
                    text: temp2 + '% '+ Dirty,
                    fillStyle: '#F93D1F',
                    strokeStyle: '#fff'
                  },
                  {
                    tooltips: Unknown,
                    text: temp1 + '% '+ Unknown,
                    fillStyle: '#797777',
                    strokeStyle: '#fff'
                  }
                  
                ];

                }

              }
              
            },                      
          };
       // });  
       this.LiveViewPopularLocation();        
      }
      catch (err) {
        throw new Error('report.component.ts' + ' - loadliveviewchart() - ' + err.message);
      }
  
  }

  LiveViewPopularLocation() {
    try
    {          
          var Loc_Value = [];
          var Loc_RoomName = [];                         
          var liveviewLocationData;                  
          liveviewLocationData = this.TotalLiveViewSource.data;                      
          var Percentage;                    
          var Loc_RoomNameCount = 0;
          var New_RoomName = []; 
          var loadRoomName = [];   
          var TruLocationName = 0;  
          var PopularLocCount = 0;   
          liveviewLocationData.forEach(function (e) {                 
            Loc_RoomName.push({Location:e.TruLocation,FullLocation:e.FullTruLocation})
          })
              
          
          liveviewLocationData.sort(this.sortByRoomName);  

          
          for(var i = 0; i < liveviewLocationData.length; i++)
          {
            Loc_RoomNameCount = 0;
            TruLocationName = 0;
            for(var j = 0; j < Loc_RoomName.length; j++)
            {
              if(liveviewLocationData[i].TruLocation == Loc_RoomName[j].Location)
              {
                Loc_RoomNameCount = Loc_RoomNameCount + 1;
              }                             
              if(Loc_RoomNameCount >= 1 && !New_RoomName.includes(liveviewLocationData[i].TruLocation))
              {
                  New_RoomName.push(Loc_RoomName[j].Location);
                  TruLocationName = 1; 
                  loadRoomName.push({'TruLocation' : Loc_RoomName[j].Location,'FullTruLocation': Loc_RoomName[j].FullLocation});             
              }
            }
            if(TruLocationName == 1)
            {
              loadRoomName.push({'Count' : Loc_RoomNameCount})
            }                                           
          }   
          for(var k = 0; k < loadRoomName.length; k++)
          {
            if(k % 2 == 0 && k < 8)
            {
              var count = loadRoomName[k+1].Count;
              Percentage = Math.round((count / liveviewLocationData.length) * 100) + '%';             
              PopularLocCount += count;
              Loc_Value.push({ Type : loadRoomName[k].TruLocation, FullType: loadRoomName[k].FullTruLocation, Value1 : count, Value2 : Percentage })
            }
          }                    
          this.Pop_LocationData = Loc_Value;         
          this.LiveViewReportCount = PopularLocCount;
          this.Pop_LocationData.sort(this.sortByLiveviewLocation);                         
    }
    catch (err) {
      throw new Error('report.component.ts' + ' - LiveViewPopularLocation() - ' + err.message);
    }
  }

sortByLiveviewLocation(number1: any, number2: any) {           
    if (number1.Value1 < number2.Value1) return 1
    else if (number1.Value1 === number2.Value1) return 0
    else return -1;
}

sortByRoomName(a: any, b: any) {           
  if (a.TruLocation < b.TruLocation) return 1
  else if (a.TruLocation === b.TruLocation) return 0
  else return -1;
}

searchLiveViewReport(filterValue: string) {
  try
  {
    if(filterValue != null)
    {        
      filterValue = filterValue.trim(); // Remove whitespace
      filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
      this.chkLiveviewsearchvalue = filterValue;          
      this.IsFilter = 1; 
      this.IsFilterData = filterValue; 
      this.getfilterLiveViewdetails()    
    }
  }
  catch (err) {
    throw new Error('report.component.ts' + ' - searchLiveViewReport() - ' + err.message);
  }
} 

cusloc_selectLocationType(selectLocationType)
{
    try
    {      
        this.selectedLocationType = selectLocationType;
        this.IsFilter = 1; 
        this.IsFilterData = selectLocationType;
        this.getfilterLiveViewdetails();         
    }        
    catch(err)
    {
      throw new Error('report.component.ts' + ' - cusloc_selectLocationType() - ' + err.message);
    }
}

CusLoc_selectStateby(selectdata)
{    
    try
    {      
        this.cusloc_selectStateBy = selectdata;  
        this.IsFilter = 1; 
        this.IsFilterData = selectdata;  
        this.getfilterLiveViewdetails();      
    }
    catch(err)
    {
      throw new Error('report.component.ts' + ' - CusLoc_selectStateby() - ' + err.message);
    }
}

getfilterLiveViewdetails()
{
    var _searchfilterData = "";
    var filtersearch;
    var _filterlocationtype = this.selectedLocationType;
    var _filterstatechangedby = this.cusloc_selectStateBy;
    var _filterLiveviewdata;
    var LiveviewfilteredArray = []; 
    _filterLiveviewdata = this.LiveViewReport;
    var chkLiveView = 0;
  
    //////LocationTypefilter////////          
    if(_filterlocationtype == "All")
      _filterLiveviewdata = this.LiveViewReport;
    else if(_filterlocationtype != undefined && _filterlocationtype != 0)
    {
      this.CusLocfilteredArray= []; 
      var list = this.LiveViewReport.filter(x => x.roomcolor == _filterlocationtype);
          list.forEach(x => {                    
            this.CusLocfilteredArray.push(x);            
          }) 
       _filterLiveviewdata = this.CusLocfilteredArray;                
    }
    else
    {
      _filterLiveviewdata = this.LiveViewReport;
    }             

    //////StateChangedbyfilter//////// 
       
      if(_filterstatechangedby == "All")
      {
        _filterLiveviewdata = _filterLiveviewdata; 
      }
      else if(_filterstatechangedby != undefined && _filterstatechangedby != 0)
      {
        var list = _filterLiveviewdata.filter(x => x.stateChangebyName == this.cusloc_selectStateBy);
          list.forEach(x => {        
            LiveviewfilteredArray.push(x);
          })   
          _filterLiveviewdata = LiveviewfilteredArray; 
      }
      else
      {
          _filterLiveviewdata = _filterLiveviewdata;
      }
    
      //////////Search///////////////////////
      if(this.chkLiveviewsearchvalue)
      {        
        _searchfilterData = "";        
        filtersearch = this.chkLiveviewsearchvalue; 

        var search_statechangeby = ""; 
        var search_roomcolor = "";           
          _searchfilterData = _filterLiveviewdata.filter(function(data)
          {                                                                                   
            if(data.stateChangebyName != null)
            {              
              search_statechangeby = data.stateChangebyName.toLowerCase().includes(filtersearch.toLowerCase());              
            }
            else            
              search_statechangeby = "";           

            if(data.FullTypeName != null)
            {
              search_roomcolor = data.FullTypeName.toLowerCase().includes(filtersearch.toLowerCase());
            }
            else
              search_roomcolor = "";                          
                         
            return data.FullGeoName.toLowerCase().includes(filtersearch.toLowerCase()) || data.FullTruLocation.toLowerCase().includes(filtersearch.toLowerCase()) ||
            search_statechangeby || data.Updatedon.toLowerCase().includes(filtersearch.toLowerCase()) || search_roomcolor  || 
            data.R_TagId.toString().includes(filtersearch); 
          })           
      }
      else
      {
        _searchfilterData = _filterLiveviewdata;
      } 
             
      this.LiveViewSource.data = _searchfilterData; 
      this.downloadLiveviewdata.data = _searchfilterData;                    
      setTimeout(() => {                              
        this.LiveviewData = [];                     
        this.LiveViewSource.sort = this.LiveViewsort;
        this.sortingDatalist_LiveViewReport(this.LiveViewSource);
        this.downloadLiveviewdata.sort = this.LiveViewsort;
        this.sortingDatalist_LiveViewReport(this.downloadLiveviewdata);
        this.downloadLiveviewdata.connect().subscribe(data =>           
        this.LiveviewData = data            
        )
      }, 0);            
}

getliveviewdivclickelement(AssetId,RoomId,clickedId)
{

    let customGeo_Data = [];
    customGeo_Data = this.LiveViewSource.data;  
    let _data;
    let state_changed1;
    let state_changed2;   
    customGeo_Data.forEach(function (data) {           
      _data = data.AssetId;     
    
      if(_data == AssetId) 
      { // _data check Start

        let autostatecontent1 = document.getElementById(AssetId+'_'+clickedId);       
        autostatecontent1.className = 'dotselectedlist';

        if(data.roomcolor == enumReportState.Clean)
        {                       
          if(clickedId == enumReportState.InUse)
          {
            state_changed1=AssetId+'_'+enumReportState.Unknown;
          }
          else
          {
            state_changed1=AssetId+'_'+enumReportState.InUse;
          }    
          let autostatecontent2 = document.getElementById(state_changed1);
          autostatecontent2.className = 'dotlist';        
        }

        else if( data.roomcolor == enumReportState.InUse)
        {                       
          if(clickedId == enumReportState.Dirty)
          {
            state_changed1=AssetId+'_'+enumReportState.Unknown;
          }
          else
          {
            state_changed1=AssetId+'_'+enumReportState.Dirty;
          }            
          let autostatecontent2 = document.getElementById(state_changed1);
          autostatecontent2.className = 'dotlist';        
        }

        else if(data.roomcolor == enumReportState.Dirty)
        {                       
          if(clickedId == enumReportState.Clean)
          {
            state_changed1=AssetId+'_'+enumReportState.Unknown;
          }
          else
          {
            state_changed1=AssetId+'_'+enumReportState.Clean;
          }    
          let autostatecontent2 = document.getElementById(state_changed1);
          autostatecontent2.className = 'dotlist';         
        }

        else if(data.roomcolor == enumReportState.Unknown)
        {                       
            if(clickedId == enumReportState.Clean)
            {
              state_changed1=AssetId+'_'+enumReportState.InUse;
              state_changed2=AssetId+'_'+enumReportState.Dirty;
            }
            else if(clickedId == enumReportState.InUse)
            {
              state_changed1=AssetId+'_'+enumReportState.Clean;
              state_changed2=AssetId+'_'+enumReportState.Dirty;
            }   
            else if(clickedId == enumReportState.Dirty)
            {
              state_changed1=AssetId+'_'+enumReportState.Clean;
              state_changed2=AssetId+'_'+enumReportState.InUse;
              
            }     
            let autostatecontent2 = document.getElementById(state_changed1);
            autostatecontent2.className = 'dotlist'; 

            let autostatecontent3 = document.getElementById(state_changed2);
            autostatecontent3.className = 'dotlist'; 
         
         }

        } // _data check end
    
  })

    var ConfirmMessageData;
        ConfirmMessageData = {        
          ConfirmMessage: "Are you sure you want to modify the Current State?" 
        }         


        let dialogRef = this.dialog.open(ConfirmMessageComponent, {
          disableClose: true,
          width: 'auto',
          height: '200px',
          panelClass: 'myapp-no-padding-dialog',
          autoFocus: false,
          data: ConfirmMessageData
        });     
        dialogRef.afterClosed().subscribe(result => {     
            if(result == "Yes")
            {                     
              this.addLiveChangeState(AssetId,RoomId,clickedId);              
            }
            else
            {
              let autostatecontent1 = document.getElementById(AssetId+'_'+clickedId);       
              autostatecontent1.className = 'dotlist';
              dialogRef.close('Cancel');
            }   

  });

}

addLiveChangeState(AssetId,RoomId,clickedId)
{
  try
  {
  var livechangestate : addLiveChangeState = 
  {
    siteId:this.SiteId, 
    authKey: localStorage.getItem("Authkey"),
    assetId: parseInt(AssetId), 
    roomId:RoomId, 
    clickedId:clickedId, 
    stateChange:this.cusloc_selectStateBy = JSON.parse(localStorage.getItem("userid"))
  }     
  this.reportService.addLiveChangeState(livechangestate).pipe(takeUntil(this._onDestroy))
    .subscribe((apiresponse_live: any[]) => {        
        if(apiresponse_live.toString() == "true")
        {
          generateAlertMessage(this.dialog, "Current State modified successfully");
          this.chkLiveviewsearchvalue = "";
          this.selectedLocationType = 0;
          this.cusloc_selectStateBy = 0;
          this.searchLiveViewInput.nativeElement.value="";
          this.getCustomizedGeo("");
        }
        else if(apiresponse_live.toString() == "false")
        {
          generateAlertMessage(this.dialog, "Current State modified failed");
        }
    })
  }
  catch (err) {
    throw new Error('liveview.component.ts' + ' - addLiveChangeState() - ' + err.message);
  }
}

exportLiveViewReportdata() {
  if(!SessionCheckwithStaff(this.router))
  {
      return;
  }
  if(this.LiveViewSource.filter != '')
  {
    this.downloadLiveviewdata.data = this.LiveViewSource.filteredData;
      setTimeout(() => {        
        this.LiveViewSource.sort = this.LiveViewsort;  
        this.sortingDatalist_LiveViewReport(this.LiveViewSource);
        this.LiveViewSource.connect().subscribe(data => this.LiveviewData = data);   
    }, 0);      
  }          
  const dialogRef = this.dialog.open(DownloadLiveviewReportComponent, {
    disableClose: true,
    width: '388px',
    height: '165px',
    panelClass: 'myapp-no-padding-dialog',
    autoFocus: false,
    data :  this.LiveviewData
  });
  dialogRef.afterClosed().subscribe(result => {
  });
}

sortingDatalist_LiveViewReport(DataSource)
{
  DataSource.sortingDataAccessor = function(data, sortHeaderId: string) {  
            
        if(sortHeaderId == 'GeoName' || sortHeaderId == 'TruLocation' || sortHeaderId == 'TypeName' || sortHeaderId == 'stateChangebyName' )
        {               
          return data[sortHeaderId].toString().toLocaleLowerCase().trim('');                               
        }   
        else
        { 
          return data[sortHeaderId]; 
        } 
    }
}

CloseRightNav(){  
  if(SidenavComponent.isClosed == false)
  {
      this.mainLayoutService.toggleSideNavRight.emit();
  }
  if(InfrastructureAlertsComponent.isinfraClosed == false)
  {
      this.mainLayoutService.toggleinfrastructureLeft.emit("close");
  } 
  if(ReportHeaderComponent.isReportMenuClosed == false)
      {
          this.reportService.toggleReportMenuNav.emit();
  }
}

ngOnDestroy() {
  clearInterval(this.liveviewinterval);
  this._onDestroy.next();
  this._onDestroy.complete();
}
}
